import { ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ctaDestination, trackEvent } from "@/lib/analytics/tracking";
import { demoBookingUrl } from "@/lib/apex25AppUrl";
import { TALK_TO_FOUNDER_URL } from "./demoHubConfig";

export function DemoFinalCTA() {
  // Same cal.com booking page as every other "Book a demo" (VITE_DEMO_BOOKING_URL), carrying the
  // visitor's UTMs.
  const bookingUrl = demoBookingUrl();

  return (
    <section className="bg-[#f8fafc] px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
      <div className="mx-auto grid max-w-7xl gap-8 border border-slate-300 bg-slate-950 p-6 text-slate-100 sm:p-8 lg:grid-cols-[1fr_auto] lg:items-center lg:p-10">
        <div className="max-w-3xl">
          <h2 className="font-space-grotesk text-3xl font-bold leading-tight text-slate-50 sm:text-4xl">
            Want to see this with your own hiring workflow?
          </h2>
          <p className="mt-4 text-base leading-7 text-slate-300">
            We can run a live walkthrough using your type of roles, candidate volume, and hiring
            process.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:justify-end">
          <Button
            asChild
            size="lg"
            className="h-12 bg-amber-500 px-5 text-slate-950 hover:bg-amber-400"
            data-demo-cta="book-demo"
          >
            <a
              href={bookingUrl}
              target="_blank"
              rel="noopener"
              onClick={() =>
                trackEvent("cta_clicked", {
                  cta_id: "book_demo",
                  cta_location: "demo_hub_final",
                  destination: ctaDestination(bookingUrl),
                })
              }
            >
              Book a live demo
              <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
            </a>
          </Button>
          <Button
            asChild
            variant="outline"
            size="lg"
            className="h-12 border-slate-700 bg-slate-900 px-5 text-slate-100 hover:bg-slate-800"
          >
            <a href={TALK_TO_FOUNDER_URL}>
              <MessageCircle className="mr-2 h-4 w-4" aria-hidden="true" />
              Talk to the founder
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
